import { render, staticRenderFns } from "./MeasureChartTabs.vue?vue&type=template&id=022d0cba&scoped=true"
import script from "./MeasureChartTabs.vue?vue&type=script&lang=js"
export * from "./MeasureChartTabs.vue?vue&type=script&lang=js"
import style0 from "./MeasureChartTabs.vue?vue&type=style&index=0&id=022d0cba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022d0cba",
  null
  
)

export default component.exports